import {ReportsContainer} from './components/report-container';

export default {
    component: ReportsContainer
};
